export const YM_COUNTER_ID = 70174765
